<style lang="scss" scoped>
.coach-card {
  border: 1px solid #d0d0d0;
}

.coach-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.coach-name {
  font-weight: 700;
  font-size: 20px;
  color: #191919;
}

.coach-email a {
  font-size: 16px;
  color: #8c1d40;
  text-decoration: underline;
}

.coach-phone {
  font-size: 16px;
  color: #191919;
}

.schedule-btn {
  background-color: #ffc627 !important;
  color: #191919 !important;
  font-weight: 600;
}
</style>

<template>
  <v-card class="coach-card rounded-lg mb-8" elevation="0">
    <!-- Card Header -->
    <v-card-title class="pa-5 pb-0">
      <div class="text-h6 font-weight-bold">{{ coachTitle }}</div>
    </v-card-title>

    <!-- Card Content -->
    <v-card-text class="pa-5 pt-4">
      <div class="d-flex align-start" style="gap: 20px">
        <!-- Coach Image -->
        <div class="flex-shrink-0">
          <img v-if="coachImage && coachImage.length" :src="coachImage" class="coach-image" alt="Coach profile" />
          <img
            v-else
            src="../assets/images/placeholder-profile-image.png"
            class="coach-image"
            alt="Coach profile placeholder"
          />
        </div>

        <!-- Coach Details -->
        <div class="flex-grow-1">
          <div class="coach-name mb-3">{{ coachName }}</div>
          <div class="coach-email mb-3">
            <a :href="href">{{ coachEmail }}</a>
          </div>
          <div class="coach-phone mb-2">Call: {{ phoneFormat(coachPhoneNumber) }}</div>
          <div class="coach-phone">Text: {{ phoneFormat(coachMobileNumber) }}</div>
        </div>
      </div>

      <!-- Schedule Button -->
      <div v-if="coachCalendlyLink" class="mt-5">
        <v-divider class="mb-5" style="border-color: #d0d0d0; opacity: 1" />
        <v-btn class="schedule-btn text-none" :ripple="false" variant="flat" rounded @click="openCalendlyLink">
          Schedule an appointment
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';

export default defineComponent({
  name: 'SuccessCoach',
  props: {},

  data() {
    return {
      panel: [0, 1]
    };
  },

  methods: {
    openCalendlyLink() {
      window.open(`${this.coachCalendlyLink}`, '_blank');
    },
    phoneFormat(number) {
      if (!number) return 'Unavailable';

      if (number && !number.match(/\(\d{3}\) \d{3}-\d{4}/gi)) {
        return '(' + number.slice(0, 3) + ') ' + number.slice(3, 6) + '-' + number.slice(6);
      }
      return number;
    }
  },

  computed: {
    coachTitle() {
      if (this.partner.toLowerCase().includes('starbucks')) {
        return 'My Pathway Coach';
      }
      return 'My Success Coach';
    },

    partner() {
      const userStore = useUserStore();
      return userStore.apis.learnerData._partnerName;
    },
    coachName() {
      const userStore = useUserStore();
      const coachDetails = userStore.apis?.learnerData?._coachDetails;
      return coachDetails?.Name || 'Coach Name Not Available';
    },
    coachEmail() {
      const userStore = useUserStore();
      const coachDetails = userStore.apis?.learnerData?._coachDetails;
      return coachDetails?.Email || 'coach@example.com';
    },
    coachPhoneNumber() {
      const userStore = useUserStore();
      const coachDetails = userStore.apis?.learnerData?._coachDetails;
      return coachDetails?.Phone || '';
    },
    coachMobileNumber() {
      const userStore = useUserStore();
      const coachDetails = userStore.apis?.learnerData?._coachDetails;
      return coachDetails?.MobilePhone || '';
    },
    coachImage() {
      const userStore = useUserStore();
      const coachDetails = userStore.apis?.learnerData?._coachDetails;
      return coachDetails?.FullPhotoUrl || '';
    },
    coachCalendlyLink() {
      const userStore = useUserStore();
      const coachDetails = userStore.apis?.learnerData?._coachDetails;
      return coachDetails?.Calendly_Scheduling_Link || '';
    },
    href() {
      return 'mailto:' + this.coachEmail;
    }
  }
});
</script>
